import { atom } from "jotai";


const uploadFilesAtom = atom<{ [blobUrl: string]: File }>({});

export default uploadFilesAtom;
